class PubSub {
  #observers = [];

  /**
   * Subscribe to an event
   * @param {string} eventName - The event name
   * @param {function} callback - The callback function
   * @returns {function} - The function to unsubscribe
   * @example
   * connectedCallback() {
   *   this.unsubscribe = pubsub.subscribe('eventname', (data) => console.log('Event triggered', data));
   * }
   *
   * disconnectedCallback() {
   *   this.unsubscribe();
   * }
   */
  subscribe(eventName, callback) {
    // Initialize the event if it doesn't exist
    if (!this.#observers[eventName]) this.#observers[eventName] = [];

    // Add the callback to the event
    this.#observers[eventName].push(callback);

    // Return a function to unsubscribe
    return () => {
      this.#observers[eventName] = this.#observers[eventName].filter((cb) => cb !== callback);
    };
  }

  /**
   * Publish an event
   * @param {string} eventName - The event name
   * @param {any} data - The data to pass to the callback
   */
  publish(eventName, data) {
    // If the event doesn't exist, return
    if (!this.#observers[eventName]) return;

    // Call all the callbacks for the event
    this.#observers[eventName].forEach((callback) => callback(data));
  }
}

const pubsub = new PubSub();
export { pubsub };
